import generateRuler from './generate-ruler';
export default generateRuler;
